module.exports = __webpack_public_path__ + "fonts/ae8aae01b92ac7cc976cc484d5a6872e.txt";